import { Kind } from 'graphql';
import type { DocumentNode, FragmentDefinitionNode } from 'graphql';

export const getRecommendationCollectionMetadataFragment = (
  document: DocumentNode
): FragmentDefinitionNode | undefined =>
  document.definitions.find(
    (definition): definition is FragmentDefinitionNode =>
      definition.kind === Kind.FRAGMENT_DEFINITION && definition.name.value === 'RecommendationCollectionMetadata'
  );
